/* ArtMindr Preview Flow — CRO v4. Чете конфигурация от data-атрибути на [data-amf-root].
   Стъпка 0 = интро. Uploadcare се зарежда по заявка, не блокира първото рисуване. */
(function(){
  'use strict';
  var root = document.querySelector('[data-amf-root]');
  if(!root) return;
  var track = function(n,p){ if(window.amfTrack){ window.amfTrack(n,p); } };
  var EMAIL_RE = new RegExp('.+@.+[.].+');
  var FREE_SHIP_MIN = 35;
  var PAGES = root.getAttribute('data-pages') || '33';
  var PRODUCTS = {
    reading:{ single:'Само книжката за четене', sub:'Персонализирана книга, ' + PAGES + ' страници' },
    coloring:{ single:'Само книжката за оцветяване', sub:'40 страници — история, игри и свободно рисуване' },
    poster:{ single:'Само плакатът A3', sub:'Висококачествен печат, рамка по избор' }
  };
  var COVERS = {
    coloring: [['soft','Меки корици',24.87],['hard','Твърди корици',39.87]],
    poster: [['classic','Класическа рамка',24.87],['premium','Премиум рамка',31.87]],
    /* Твърдите са първи нарочно — те са по подразбиране. */
    reading: [['hard','Твърди корици',49.87],['soft','Меки корици',39.87]]
  };
  var MB_BASE = 89.87, MB_HARD_EXTRA = 15, VS_TOTAL = parseFloat(root.getAttribute('data-vs-total')) || 120;
  var state = window.amfState = { name:'', gender:'момиче', product: root.getAttribute('data-default-product') || 'reading', theme:'fairy', themeLabel:'Феи', cover:'hard', coverLabel:'Твърди корици', email:'', photoUrl:null, consent:false, previewUrl:'', previewId:null, serverPreviewId:'', innerUrl:'', innerText:'', offer:'single', mbHard:false, backMsg:'', wishes:'', photoUrl2:'' };
  function $(s,c){ return (c||root).querySelector(s); }
  function $all(s,c){ return Array.prototype.slice.call((c||root).querySelectorAll(s)); }
  function money(n){ return '€' + n.toFixed(2); }
  function go(n){ $all('[data-amf-step]').forEach(function(s){ s.classList.toggle('is-active', s.getAttribute('data-amf-step')==String(n)); }); window.scrollTo({top:0,behavior:'smooth'}); if(n===6){ onEnterPreview(); } }
  function cur(){ var a=$('.amf__screen.is-active'); return a?parseInt(a.getAttribute('data-amf-step'),10):0; }
  function syncNames(){
    var nm = state.name || 'детето';
    $all('[data-amf-nameout]').forEach(function(e){ e.textContent = nm; });
    var bn=$('[data-amf-bigname]'); if(bn) bn.textContent = nm;
    /* Родът вървеше по подразбиране мъжки — пишеше „Мария в НЕГОВИЯ свят“
       и „Мария като ГЕРОЯ“. Тук думите се сменят според избрания пол. */
    var girl = state.gender === 'момиче';
    $all('[data-amf-poss]').forEach(function(e){ e.textContent = girl ? 'нейния' : 'неговия'; });
    $all('[data-amf-heroword]').forEach(function(e){ e.textContent = girl ? 'героинята' : 'героя'; });
  }
  function refreshBtns(){ $all('[data-amf-need]').forEach(function(b){ var need=b.getAttribute('data-amf-need'), ok=true; if(need==='file') ok=!!state.photoUrl && !!state.consent; if(need==='name') ok=state.name.trim().length>0; if(need==='email') ok=EMAIL_RE.test(state.email); b.disabled=!ok; }); }

  /* ── Uploadcare по заявка: сваля се при първия преход от интрото, не при зареждане ── */
  var ucLoading = false;
  function loadUploadcare(cb){
    if(window.uploadcare){ if(cb) cb(); return; }
    if(ucLoading){ if(cb) document.addEventListener('amf-uc-ready', cb, { once:true }); return; }
    ucLoading = true;
    var sc = document.createElement('script');
    sc.src = 'https://ucarecdn.com/libs/widget/3.x/uploadcare.full.min.js';
    sc.charset = 'utf-8';
    sc.onload = function(){ document.dispatchEvent(new Event('amf-uc-ready')); if(cb) cb(); };
    sc.onerror = function(){ ucLoading = false; console.error('[amf] uploadcare failed to load'); };
    document.head.appendChild(sc);
  }

  var dropEl=$('[data-amf-drop]'), emptyEl=$('[data-amf-drop-empty]'), doneEl=$('[data-amf-drop-done]'), thumbEl=$('[data-amf-thumb]');
  function openUploader(){
    loadUploadcare(function(){
      if(!window.uploadcare) return;
      var dialog = uploadcare.openDialog(null, { publicKey: window.AMF_UC_KEY, imagesOnly:true, crop:'1:1', tabs:'file camera', locale:'bg' });
      dialog.done(function(file){ file.promise().then(function(info){
        state.photoUrl = info.cdnUrl;
        if(thumbEl) thumbEl.src = info.cdnUrl + '-/preview/240x240/';
        if(emptyEl) emptyEl.style.display='none';
        if(doneEl) doneEl.style.display='flex';
        if(dropEl) dropEl.classList.add('has-file');
        refreshBtns();
      }); });
    });
  }
  if(dropEl) dropEl.addEventListener('click', openUploader);

  /* ── Личното послание на гърба (безплатно) + желания + втора снимка ──
     Всичко е по избор. Нищо тук не блокира бутона за поръчка. */
  function bindCounter(sel, counterSel, key){
    var el = $(sel); if(!el) return;
    var out = $(counterSel);
    var sync = function(){
      state[key] = el.value;
      if(out) out.textContent = String(el.value.length);
    };
    el.addEventListener('input', sync);
    sync();
  }
  bindCounter('[data-amf-backmsg]', '[data-amf-backmsg-n]', 'backMsg');
  bindCounter('[data-amf-wishes]',  '[data-amf-wishes-n]',  'wishes');

  var xBtn   = $('[data-amf-extra-photo]');
  var xEmpty = $('[data-amf-extra-photo-empty]');
  var xDone  = $('[data-amf-extra-photo-done]');
  var xThumb = $('[data-amf-extra-photo-thumb]');
  if(xBtn){
    xBtn.addEventListener('click', function(){
      loadUploadcare(function(){
        if(!window.uploadcare) return;
        var d = uploadcare.openDialog(null, { publicKey: window.AMF_UC_KEY, imagesOnly:true, crop:'1:1', tabs:'file camera', locale:'bg' });
        d.done(function(file){ file.promise().then(function(info){
          state.photoUrl2 = info.cdnUrl;
          if(xThumb) xThumb.src = info.cdnUrl + '-/preview/88x88/';
          if(xEmpty) xEmpty.hidden = true;
          if(xDone)  xDone.hidden  = false;
          if(window.amfTrack) window.amfTrack('extra_photo_added', {});
        }); });
      });
    });
  }

  function renderThemes(){
    var T = {
      coloring: [['Феи','fairy'],['Принцеси','princess'],['Ледена принцеса','ice_princess'],['Балет','ballet'],['Супергерой','superhero'],['Динозаври','dinosaurs'],['Футбол','football'],['Космос','astronaut'],['Доктор','doctor'],['Подводно','mermaid'],['Рицар','knight'],['Изгубеният символ','lost_symbol']],
      reading: [['Феи','fairy'],['Принцеси','princess'],['Русалки','mermaid'],['Космос','astronaut'],['Супергерои','superhero'],['Около света','vacation']],
      /* „Феи“ е махната: продукт „Плакат A3 — Феи“ НЕ съществува, а беше първа в списъка,
         значи избрана по подразбиране — всяка поръчка за плакат без смяна на темата
         умираше на добавянето в количката (вариантите ѝ връщат 410). */
      poster: [['Принцеси','princess'],['Русалки','mermaid'],['Космос','astronaut'],['Супергерои','superhero'],['Ледена принцеса','ice_princess'],['Балет','ballet'],['Динозаври','dinosaurs'],['Футбол','football']]
    };
    /* „Първи учебен ден“ се показва само ако е пуснато от настройките на секцията.
       Сървърът трябва да познава темата 'school' — иначе прегледът ще гръмне. */
    if(root.getAttribute('data-school') === '1'){
      T.reading = T.reading.concat([['Първи учебен ден','school']]);
    }
    var wrap = $('[data-amf-theme]'); if(!wrap) return;
    var list = T[state.product] || T.reading;
    wrap.innerHTML = list.map(function(t,i){ return '<button type="button" class="amf__pill'+(i===0?' is-active':'')+'" data-label="'+t[0]+'" data-slug="'+t[1]+'">'+t[0]+'</button>'; }).join('');
    state.themeLabel = list[0][0]; state.theme = list[0][1];
    $all('.amf__pill', wrap).forEach(function(p){ p.addEventListener('click', function(){
      $all('.amf__pill', wrap).forEach(function(x){ x.classList.remove('is-active'); }); p.classList.add('is-active');
      state.themeLabel = p.getAttribute('data-label'); state.theme = p.getAttribute('data-slug');
      /* смяната на темата може да смени и наличните корици (училището е само твърди) */
      var cv = coversFor();
      var stillValid = false;
      for(var i=0;i<cv.length;i++){ if(cv[i][0]===state.cover) stillValid = true; }
      if(!stillValid){ state.cover = cv[0][0]; state.coverLabel = cv[0][1]; }
      renderOffer();
      syncBoxCard();
    }); });
    syncBoxCard();
  }

  /* „Първи учебен ден“: кутията се показва като при всички теми, но носи училищната
     книжка за четене, а оцветяването и плакатът са по друга тема. Казваме го на картата,
     вместо да го крием — човек трябва да знае какво получава. */
  function syncBoxCard(){
    var box = $('[data-amf-card="box"]');
    if(!box) return;
    box.style.display = '';
    var note = $('[data-amf-box-note]', box);
    if(note){
      var isSchool = state.theme === 'school';
      note.hidden = !isSchool;
      if(isSchool){
        note.textContent = 'За тази тема: книжката за четене е „Първи учебен ден“. Книжката за оцветяване и плакатът са по тема по избор на детето — уточняваме я по имейл.';
      }
    }
  }

  /* От 16.08 „Първи учебен ден“ вече има и меки корици, значи ползва общия списък. */
  function coversFor(){
    return COVERS[state.product] || COVERS.reading;
  }

  function singlePrice(){
    var covers = coversFor();
    var row = null;
    for (var i=0;i<covers.length;i++){ if(covers[i][0]===state.cover){ row=covers[i]; } }
    if(!row){ row = covers[0]; state.cover = row[0]; state.coverLabel = row[1]; }
    return row[2];
  }
  function boxPrice(){ return MB_BASE + (state.mbHard ? MB_HARD_EXTRA : 0); }
  function currentPrice(){ return state.offer === 'box' ? boxPrice() : singlePrice(); }

  function renderOffer(){
    var p = PRODUCTS[state.product] || PRODUCTS.reading;
    var st=$('[data-amf-single-title]'); if(st) st.textContent = p.single;
    var ss=$('[data-amf-single-sub]'); if(ss) ss.textContent = p.sub;
    var covers = coversFor();
    /* ВАЖНО: търси се САМО вътре в офертата — иначе селекторът хваща корицата на книгата и я трие */
    var offerBox = $('[data-amf-offer]');
    var wrap = offerBox ? offerBox.querySelector('[data-amf-cover]') : null;
    if(wrap){
      if(covers.length>1){
        wrap.style.display='flex';
        wrap.innerHTML = covers.map(function(c){ return '<button type="button" class="amf__pill'+(c[0]===state.cover?' is-active':'')+'" data-cover="'+c[0]+'" data-label="'+c[1]+'">'+c[1]+' · '+money(c[2])+'</button>'; }).join('');
        $all('.amf__pill',wrap).forEach(function(p2){ p2.addEventListener('click',function(ev){ ev.preventDefault(); ev.stopPropagation(); $all('.amf__pill',wrap).forEach(function(x){ x.classList.remove('is-active'); }); p2.classList.add('is-active'); state.cover=p2.getAttribute('data-cover'); state.coverLabel=p2.getAttribute('data-label'); refreshPrices(); }); });
      } else { wrap.style.display='none'; wrap.innerHTML=''; state.cover=covers[0][0]; state.coverLabel=covers[0][1]; }
    }
    refreshPrices();
  }

  function refreshPrices(){
    var sPrice = singlePrice();
    var sp=$('[data-amf-single-price]'); if(sp) sp.textContent = money(sPrice);
    var sh=$('[data-amf-single-ship]'); if(sh) sh.textContent = sPrice >= FREE_SHIP_MIN ? '✓ Безплатна доставка' : 'Доставка €4,09 · безплатна над €' + FREE_SHIP_MIN;
    var bp=$('[data-amf-box-price]'); if(bp) bp.textContent = money(boxPrice());
    var vt=$('[data-amf-vs-total]'); if(vt) vt.textContent = money(VS_TOTAL + (state.mbHard ? MB_HARD_EXTRA : 0));
    var vs=$('[data-amf-vs-save]'); if(vs) vs.textContent = money(VS_TOTAL - MB_BASE);
    var stp=$('[data-amf-sticky-price]'); if(stp) stp.textContent = money(currentPrice());
    $all('[data-amf-card]').forEach(function(c){ c.classList.toggle('is-checked', c.getAttribute('data-amf-card')===state.offer); });
  }

  var offerSeen = false, stickyTimer = null;
  window.amfDelaySticky = function(ms){
    var sticky=$('[data-amf-sticky]');
    if(!sticky) return;
    sticky.classList.remove('is-visible');
    if(stickyTimer) clearTimeout(stickyTimer);
    stickyTimer = setTimeout(function(){ sticky.classList.add('is-visible'); }, ms || 10000);
  };
  function onEnterPreview(){
    renderOffer();
    window.amfDelaySticky(6000);
    var offer=$('[data-amf-offer]');
    if(offer && 'IntersectionObserver' in window && !offerSeen){
      var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting && !offerSeen){ offerSeen = true; track('preview_scrolled_to_offer', {}); io.disconnect(); } }); }, { threshold: 0.3 });
      io.observe(offer);
    }
  }

  $all('[data-amf-offer-radio]').forEach(function(r){ r.addEventListener('change', function(){ state.offer = r.value === 'box' ? 'box' : 'single'; refreshPrices(); track('offer_option_changed', { option: state.offer === 'box' ? 'masterbox' : 'single' }); }); });
  var hard=$('[data-amf-hardcover]');
  if(hard){ hard.addEventListener('change', function(){ state.mbHard = !!hard.checked; if(state.offer !== 'box'){ var br=$('[data-amf-card="box"] [data-amf-offer-radio]'); if(br){ br.checked = true; state.offer='box'; } } refreshPrices(); track('hardcover_toggled', { on: state.mbHard }); }); }

  /* Съгласието блокира бутона наравно със снимката — иначе отметката е украса. */
  var consentI=$('[data-amf-consent]');
  if(consentI){ consentI.addEventListener('change', function(){ state.consent = !!consentI.checked; refreshBtns(); }); }

  var nameI=$('[data-amf-name]'); if(nameI){ nameI.addEventListener('input', function(){ state.name=nameI.value; syncNames(); refreshBtns(); }); }
  var emailI=$('[data-amf-email]'); if(emailI){ emailI.addEventListener('input', function(){ state.email=emailI.value; refreshBtns(); }); }
  var pgen = $('[data-amf-gender]');
  if(pgen){ $all('.amf__pill', pgen).forEach(function(p){ p.addEventListener('click', function(){ $all('.amf__pill', pgen).forEach(function(x){ x.classList.remove('is-active'); }); p.classList.add('is-active'); state.gender = p.getAttribute('data-v'); syncNames(); }); }); }
  var pp = $('[data-amf-product]');
  if(pp){ $all('.amf__prod', pp).forEach(function(p){ p.addEventListener('click', function(){ $all('.amf__prod', pp).forEach(function(x){ x.classList.remove('is-active'); }); p.classList.add('is-active'); state.product = p.getAttribute('data-v'); var c=(COVERS[state.product]||COVERS.reading)[0]; state.cover=c[0]; state.coverLabel=c[1]; renderThemes(); }); }); }

  $all('[data-amf-next]').forEach(function(b){ b.addEventListener('click', function(){ if(b.disabled) return; loadUploadcare(null); if(cur()===0){ track('intro_cta_clicked', {}); } go(cur()+1); }); });
  $all('[data-amf-back]').forEach(function(b){ b.addEventListener('click', function(){ go(Math.max(0,cur()-1)); }); });
  var gen=$('[data-amf-generate]');
  if(gen){ gen.addEventListener('click', function(){ if(gen.disabled) return; go(5); startLoading(); }); }

  var phaseTimer=null;
  var PHASE_COUNT = 7, PHASE_SECS = 10;
  function setPhase(n){ $all('.am-preview-phase').forEach(function(ph){ ph.classList.toggle('is-on', ph.getAttribute('data-phase')==String(n)); }); }
  function startLoading(){
    var fill=$('[data-amf-fill]'), cnt=$('[data-amf-count]'), total=150, left=total;
    /* Пръстенът се пълни от същия процент като лентата. r=58 → обиколка 364,4 */
    var ring=$('[data-amf-ring2]'), CIRC = 2 * Math.PI * 58;
    if(ring){ ring.style.strokeDasharray = CIRC.toFixed(1); ring.style.strokeDashoffset = CIRC.toFixed(1); }
    var setRing = function(pct){ if(ring) ring.style.strokeDashoffset = (CIRC * (1 - pct/100)).toFixed(1); };
    if(fill) fill.style.width='6%';
    setRing(6);
    if(cnt) cnt.textContent='остават около ' + left + ' сек';
    setPhase(1);
    var iv=setInterval(function(){
      left-=1;
      var elapsed = total - left;
      var pct=Math.min(96, Math.round(elapsed/total*96));
      if(fill) fill.style.width=pct+'%';
      setRing(pct);
      if(cnt) cnt.textContent = left>5 ? ('остават около ' + left + ' сек') : 'почти готово…';
      if(elapsed>0 && elapsed%PHASE_SECS===0){ setPhase((Math.floor(elapsed/PHASE_SECS) % PHASE_COUNT) + 1); }
      if(left<=0){ clearInterval(iv); if(cnt) cnt.textContent='почти готово…'; }
    },1000);
    phaseTimer = iv;
    if(typeof window.amfGenerate==='function'){ try{ window.amfGenerate(state); }catch(e){ console.error(e); window.amfPreviewReady(''); } } else { setTimeout(function(){ window.amfPreviewReady(''); }, 6000); }
  }

  window.amfPreviewReady=function(url){
    if(phaseTimer){ clearInterval(phaseTimer); phaseTimer=null; }
    var stage=$('[data-amf-stage]');
    var fail=$('[data-amf-fail]');
    var after=$('[data-amf-afterbook]');
    if(url){
      if(stage){
        stage.style.display='';
        var cov=stage.querySelector('[data-amf-bookcover]');
        if(cov){ cov.style.display=''; }
        var front=stage.querySelector('[data-amf-cover-front]') || cov;
        if(front){ front.innerHTML='<img src="'+url+'" alt="Прегледът">'; }
      }
      /* Приликата, показана вместо обещана: качената снимка до готовата корица.
         Показва се само ако наистина имаме и двете — иначе половин сравнение
         е по-лошо от никакво. */
      var match=$('[data-amf-match]');
      if(match){
        var ph=$('[data-amf-match-photo]'), cv=$('[data-amf-match-cover]');
        if(state.photoUrl && ph && cv){
          ph.src = state.photoUrl + (state.photoUrl.indexOf('ucarecdn')>-1 ? '-/preview/560x560/-/quality/lighter/' : '');
          cv.src = url;
          match.hidden = false;
          track('match_shown', {});
        } else {
          match.hidden = true;
        }
      }
      if(fail) fail.style.display='none';
      if(after) after.style.display='';
    } else {
      if(stage){ stage.style.display='none'; }
      if(after) after.style.display='none';
      if(fail) fail.style.display='block';
    }
    track('preview_completed', { success: !!url, product: state.product, theme: state.theme });
    /* PreviewGenerated се праща САМО от connect.js (със server event_id, за CAPI дедупликация) */
    go(6);
  };

  $all('[data-amf-order]').forEach(function(b){ b.addEventListener('click', function(){ track('sticky_cta_clicked', { offer: state.offer === 'box' ? 'masterbox' : 'single' }); try { if (typeof window.fbq === 'function') { window.fbq('trackCustom', 'PreviewCTAClick', { offer: state.offer === 'box' ? 'masterbox' : 'single' }); } } catch(e) {} if(typeof window.amfOnOrder==='function'){ window.amfOnOrder(state); } }); });

  renderThemes(); syncNames(); refreshBtns();
})();